module.exports = __webpack_public_path__ + "img/DSC_0102.daee4180.jpg";